module.exports = __webpack_public_path__ + "img/2.25b4e922.jpg";